import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import ReactHookCheckbox from 'components/ReactHookCheckbox';

const InletDamper = ({ control, tableView }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Inlet Damper</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.inletDamperQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.inletDamperType'
                type='text'
                control={control}
                label='Type'
                options={[
                    {
                        label: 'Parallel',
                        id: 'Parallel'
                    },
                    {
                        label: 'Opposed',
                        id: 'Opposed'
                    }
                ]}
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperMaterial'
                type='text'
                control={control}
                label='Material'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.inletDamperBlades'
                type='text'
                control={control}
                label='Blades'
                options={[
                    {
                        label: 'Flat',
                        id: 'Flat'
                    },
                    {
                        label: 'Envelope',
                        id: 'Envelope'
                    }
                ]}
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.inletDamperControl'
                type='text'
                control={control}
                label='Control'
                options={[
                    {
                        label: 'Actuator',
                        id: 'Actuator'
                    },
                    {
                        label: 'Manual',
                        id: 'Manual'
                    }
                ]}
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.inletDamperSeal'
                type='text'
                control={control}
                label='Seal'
                options={[
                    {
                        label: 'Bush',
                        id: 'Bush'
                    },
                    {
                        label: 'Bearing',
                        id: 'Bearing'
                    },
                    {
                        label: 'Stuffing Box',
                        id: 'Stuffing Box'
                    }
                ]}
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookCheckbox
                control={control}
                name='attributes.inletDamperServiceable'
                label='Serviceable'
                style={{width: '10%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.inletDamperNotes'
                type='textarea'
                control={control}
                label='Notes'
                style={{width: '24%', marginRight: '1%'}}
                InputProps={{
                    multiline:true
                }}
            />
        </>
    );
};

export default InletDamper;
